
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./PublicCadastroForm.css";
import "../../App.css";

import criarCadastroPublicDTO from '../../types/CadastrPublicDTO';
import logo from '../../assets/img/logo-header.png';
import cadastro from '../../assets/icons/perfil.png';


export default function PublicCadastroForm({ perfil, onSubmit, onClose }) {
  
  const navigate = useNavigate();

  const [form, setForm] = useState({
    idCadastro: null,
    nome: "",
    nascimento: "",
    email: "",
    login: "",
    senha: "",
    confirmarSenha: "",
    celular: "",
    rua: "",
    numero: "",
    bairro: "",
    complemento: "",
    cep: "",
    cidade: "",
    uf: "",
  });

  const [retorno, setRetorno] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);

  const [submitState, setSubmitState] = useState("IDLE"); 
// IDLE | SUCCESS | ERROR


  // == Dados do perfil====================================
  useEffect(() => {
    if (perfil) {
      setForm((prev) => ({
        ...prev,
        idCadastro: perfil.idCadastro ?? null,
        nome: perfil.nome ?? "",
        nascimento: perfil.nascimento ?? "",
        email: perfil.email ?? "",
        login: perfil.login ?? "",
        celular: perfil.celular ?? "",
        rua: perfil.rua ?? "",
        numero: perfil.numero ?? "",
        bairro: perfil.bairro ?? "",
        complemento: perfil.complemento ?? "",
        cep: perfil.cep ?? "",
        cidade: perfil.cidade ?? "",
        uf: perfil.uf ?? "",
      }));
    }
  }, [perfil]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  }

 
  // == Consulta CEP (ViaCEP) ====================================
  async function buscarCep() {
    const cepLimpo = form.cep.replace(/\D/g, "");

    if (cepLimpo.length !== 8) {
      alert("CEP inválido. Digite 8 números.");
      //setRetorno({ tipo: "erro", mensagem: "CEP inválido. Digite 8 números." });
      return;
    }

    try {
      setBuscandoCep(true);

      const resposta = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (!resposta.ok) {
        alert("Erro ao consultar o CEP.");
        //setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
        return;
      }

      const dados = await resposta.json();

      if (dados.erro) {
        alert("CEP não encontrado.");
        //setRetorno({ tipo: "erro", mensagem: "CEP não encontrado." });
        return;
      }

      setForm((prev) => ({
        ...prev,
        rua: dados.logradouro || "",
        bairro: dados.bairro || "",
        cidade: dados.localidade || "",
        uf: dados.uf || "",
      }));

    } catch (error) {
      setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
      console.error(error);
    } finally {
      setBuscandoCep(false);
    }
  }

  // == Validação ====================================
  function validarCampos() {
    const newErrors = {};

    if (!form.nome.trim()) newErrors.nome = "Informe o nome";
    if (!form.email.trim()) newErrors.email = "Informe o e-mail";
    if (!form.login.trim()) newErrors.login = "Informe o login";
    if (!form.senha.trim()) newErrors.senha = "Informe a senha";
    if (!form.confirmarSenha.trim()) newErrors.confirmarSenha = "Confirme a senha";

    if (form.senha?.trim() && form.confirmarSenha?.trim() && 
        form.senha !== form.confirmarSenha ) newErrors.confirmarSenha = "As senhas não coincidem";

    if (!form.celular.trim()) newErrors.celular = "Informe o celular";

    return newErrors;
  }

  // == Submit ====================================
  async function handleSubmit(e) {
    e.preventDefault();

    const newErrors = validarCampos();
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      const payload = criarCadastroPublicDTO({
        nome: form.nome,
        nascimento: form.nascimento, 
        email: form.email, 
        login: form.login, 
        senha: form.senha, 
        celular: form.celular,
        rua: form.rua, 
        numero: Number(form.numero), 
        bairro: form.bairro, 
        complemento: form.complemento, 
        cep: form.cep, 
        cidade: form.cidade,
        uf: form.uf
      });

      delete payload.confirmarSenha;

      if (onSubmit) {
        await onSubmit(payload);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Cadastro realizado com sucesso!",
        });

        setSubmitState("SUCCESS");

      }
    } catch (error) {
      setRetorno({
        tipo: "erro",
        mensagem: "Erro ao realizar o cadastro.",
      });
      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="Cadastro-form-Container">
      {(submitState === "IDLE" || submitState === "ERROR") && (
        <form onSubmit={handleSubmit}>
          <div className="Cadastro-form-Fechar" onClick={onClose}> X </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Nome: *</div>
            <input name="nome" value={form.nome} onChange={handleChange} />
            {errors.nome && <span style={{ color: "red" }}>{errors.nome}</span>}
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Nascimento: *</div>
            <input type="date" name="nascimento" value={form.nascimento} onChange={handleChange} />
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Email: *</div>
            <input name="email" value={form.email} onChange={handleChange} />
            {errors.email && <span style={{ color: "red" }}>{errors.email}</span>}
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Login: *</div>
            <input name="login" value={form.login} onChange={handleChange} />
            {errors.login && <span style={{ color: "red" }}>{errors.login}</span>}
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Senha: *</div>
            <input type="password" name="senha" value={form.senha} onChange={handleChange} />
             {errors.senha && <span style={{ color: "red" }}>{errors.senha}</span>}
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Confirmar Senha: *</div>
            <input
              type="password"
              name="confirmarSenha"
              value={form.confirmarSenha}
              onChange={handleChange}
            />
            {errors.confirmarSenha && <span style={{ color: "red" }}>{errors.confirmarSenha}</span>}
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Celular: *</div>
            <input name="celular" value={form.celular} onChange={handleChange} />
             {errors.celular && <span style={{ color: "red" }}>{errors.celular}</span>}
          </div>

          <div className="Cadastro-form-alinhamento-cep">
            <div className="Cadastro-form-label">CEP:</div>

            <div style={{ display: "flex", gap: "10px", flexDirection: "row" }}>
              <input
                name="cep"
                value={form.cep}
                onChange={handleChange}
                maxLength={9}
                placeholder="00000-000"
                className="cep"
              />

              <button type="button" onClick={buscarCep} disabled={buscandoCep}>
                {buscandoCep ? "Buscando..." : "Buscar"}
              </button>
            </div>
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Rua:</div>
            <input name="rua" value={form.rua} onChange={handleChange} />
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Número:</div>
            <input name="numero" value={form.numero} onChange={handleChange} />
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Bairro:</div>
            <input name="bairro" value={form.bairro} onChange={handleChange} />
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Complemento:</div>
            <input name="complemento" value={form.complemento} onChange={handleChange} />
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">Cidade:</div>
            <input name="cidade" value={form.cidade} onChange={handleChange} />
          </div>

          <div className="Cadastro-form-alinhamento">
            <div className="Cadastro-form-label">UF:</div>
            <input name="uf" maxLength={2} value={form.uf} onChange={handleChange} />
          </div>

          <div className="Cadastro-form-alinhamento-button">
            <button type="submit" disabled={loading}>
              {loading ? "Enviando..." : "Cadastrar"}
            </button>

            <div className="Cadastro-button">
              <Link to="/Login">Voltar</Link>
            </div>
          </div>
        </form>
      )}

      {submitState === "SUCCESS" && ( 
        <div className="Cadastro-Confirmação">
          <img src={logo} alt="Logotipo" className="Cadastro-form-logo" />

          <div className="Cadastro-form-title">
            <img src={cadastro} alt="Cadastro" className="icon" />
            Confirmação de cadastro
          </div>
          <div className="Cadastro-form-linha"></div>

          <div className="Cadastro-form-alinhamento-button-confirmação">
            <div className="Cadastro-button-confirmação">
              <Link to="/Login">Página de Login</Link>
            </div>

            <div className="Cadastro-button-confirmação">
              <Link to="/">Voltar</Link>
            </div>
          </div>       

        </div>
      )}
    </div>
  );
}
